import { ImageActionType } from 'redhotpie-shared-lib/enum/ImageAction';
import { ProfileImageType } from 'redhotpie-shared-lib/enum/ProfileImage';
import { LoginUserType } from 'redhotpie-shared-lib/enum/User';

export default class ProfilePhoto {
  photoId: number;
  height: number;
  width: number;
  imageType: ProfileImageType;
  isPublic: boolean;
  classification: number;
  userType: LoginUserType;
  showSafeMode: boolean;
  imageActionType: ImageActionType;
  galleryId: number;
  isAccepted: boolean;
  memberLikeCount: number;
  isLiked: boolean;
  sortNumber: number;
  thumbUrl: string;
  fullUrl: string;

  constructor() {
    this.photoId = 0;
    this.height = 0;
    this.width = 0;
    this.imageType = ProfileImageType.NoPhoto;
    this.isPublic = false;
    this.classification = 0;
    this.userType = LoginUserType.General;
    this.showSafeMode = false;
    this.imageActionType = ImageActionType.NoAction;
    this.galleryId = 0;
    this.isAccepted = false;
    this.memberLikeCount = 0;
    this.isLiked = false;
    this.sortNumber = 0;
    this.thumbUrl = '';
    this.fullUrl = '';
    this.thumbUrl = '';
    this.fullUrl = '';
  }

  static mappingObject(_obj: Record<string, any>): ProfilePhoto {
    const obj = new ProfilePhoto();
    // Map properties from _obj (which are in PascalCase) to camelCase properties
    obj.photoId = _obj.PhotoID || obj.photoId;
    obj.height = _obj.Height || obj.height;
    obj.width = _obj.Width || obj.width;
    obj.imageType = _obj.ImageType !== undefined ? _obj.ImageType : obj.imageType;
    obj.isPublic = _obj.IsPublic !== undefined ? _obj.IsPublic : obj.isPublic;
    obj.classification = _obj.Classification || obj.classification;
    obj.userType = _obj.UserType !== undefined ? _obj.UserType : obj.userType;
    obj.showSafeMode = _obj.ShowSafeMode !== undefined ? _obj.ShowSafeMode : obj.showSafeMode;
    obj.imageActionType = _obj.ImageActionType !== undefined ? _obj.ImageActionType : obj.imageActionType;
    obj.galleryId = _obj.GalleryID || obj.galleryId;
    obj.isAccepted = _obj.IsAccepted !== undefined ? _obj.IsAccepted : obj.isAccepted;
    obj.memberLikeCount = _obj.MemberLikeCount || obj.memberLikeCount;
    obj.isLiked = _obj.IsLiked !== undefined ? _obj.IsLiked : obj.isLiked;
    obj.sortNumber = _obj.SortNumber || obj.sortNumber;
    obj.thumbUrl = _obj.ThumbUrl || obj.thumbUrl;
    obj.fullUrl = _obj.FullUrl || obj.fullUrl;

    return obj;
  }
}
